import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { EASE, Reveal } from "@/components/Reveal";

const STATS = [
  { slug: "countries", value: 70, suffix: "+", label: "Countries served", decimals: 0 },
  { slug: "on-time", value: 99.9, suffix: "%", label: "On-time delivery", decimals: 1 },
  { slug: "shipments", value: 4.2, suffix: "M", label: "Shipments a year", decimals: 1 },
  { slug: "ops", value: 24, suffix: "/7", label: "Operations command", decimals: 0 },
];

function Counter({ value, decimals, suffix }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-15% 0px" });
  const [display, setDisplay] = useState((0).toFixed(decimals));

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 2.2,
      ease: EASE,
      onUpdate: (v) => setDisplay(v.toFixed(decimals)),
    });
    return () => controls.stop();
  }, [inView, value, decimals]);

  return (
    <span ref={ref}>
      {display}
      <span className="text-[#FF3B30]">{suffix}</span>
    </span>
  );
}

export function Network() {
  return (
    <section
      id="network"
      data-testid="network-section"
      className="scroll-mt-20 px-6 py-28 lg:px-12 lg:py-40"
    >
      <Reveal>
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.3em] text-white/50">
              <span className="h-px w-10 bg-[#FF3B30]" />
              The network
            </p>
            <h2 className="mt-6 font-display text-4xl font-semibold uppercase leading-[0.95] tracking-tight sm:text-5xl lg:text-7xl">
              Proof, in numbers.
            </h2>
          </div>
          <p className="max-w-sm text-base leading-relaxed text-white/60">
            Hubs in Rewa and Mumbai. Linehaul on every
            continent. Capacity that bends before it breaks.
          </p>
        </div>
      </Reveal>

      <Reveal delay={0.15} className="mt-16 lg:mt-20">
        <div className="grid grid-cols-1 border border-white/10 sm:grid-cols-2 lg:grid-cols-4">
          {STATS.map((stat, i) => (
            <div
              key={stat.slug}
              data-testid={`stat-${stat.slug}`}
              className={`group p-10 transition-colors duration-500 hover:bg-white/[0.03] lg:p-12 ${
                i > 0 ? "border-t border-white/10 sm:border-t-0 sm:border-l" : ""
              } ${i === 2 ? "max-lg:border-t max-lg:sm:border-l-0 lg:border-l" : ""} ${
                i === 3 ? "max-lg:border-t" : ""
              }`}
            >
              <span className="font-display text-6xl font-semibold tracking-tight lg:text-7xl">
                <Counter value={stat.value} decimals={stat.decimals} suffix={stat.suffix} />
              </span>
              <p className="mt-4 text-xs font-semibold uppercase tracking-[0.25em] text-white/50 transition-colors duration-500 group-hover:text-white/80">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </Reveal>
    </section>
  );
}
